import { Controller } from "@hotwired/stimulus"

// Slider de testimonios de la landing Markets Experience.
// Muestra un testimonio cada vez, autoavanza cada 6s y permite navegar con
// flechas y puntos. Reinicia el temporizador al interactuar.
export default class extends Controller {
  static targets = ["slide", "dot"]

  connect() {
    this.index = 0
    this.startTimer()
  }

  disconnect() {
    this.stopTimer()
  }

  next() { this.show(this.index + 1) }
  prev() { this.show(this.index - 1) }
  goTo(event) { this.show(Number(event.currentTarget.dataset.index)) }

  show(i) {
    const total = this.slideTargets.length
    if (total === 0) return
    this.index = (i + total) % total
    this.slideTargets.forEach((slide, n) => slide.classList.toggle("is-active", n === this.index))
    this.dotTargets.forEach((dot, n) => dot.classList.toggle("is-active", n === this.index))
    this.restartTimer()
  }

  startTimer() {
    if (this.slideTargets.length > 1) this.timer = setInterval(() => this.next(), 6000)
  }

  stopTimer() {
    if (this.timer) clearInterval(this.timer)
  }

  restartTimer() {
    this.stopTimer()
    this.startTimer()
  }
}
